import { Box, Text } from '@mantine/core'
import type { ReactNode } from 'react'

export function HowToPlayBullet({
  children,
  maw = 320,
  w,
}: {
  children: ReactNode
  maw?: number
  w?: number | string
}) {
  return (
    <Box fz={16} lh={1.3} ta="left" opacity={1} maw={maw} w={w} pos="relative">
      <Box
        component="span"
        pos="absolute"
        left={'-1.1em'}
        top={'0.4em'}
        w={7}
        h={7}
        bdrs={10}
        bg="gray"
        opacity={0.4}
      />
      {children}
    </Box>
  )
}
